import $http from '@Config/axios';
// import $store from '@Store';

const prefix = 'cadastro-signature';
// const tipo = 'Cadastro';
// const artigo = 'o';

export default {
  show(id) {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/${id}`)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  showProfissional(id) {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/profissional/${id}`)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  showInsitituicao(id) {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/usuario/${id}`)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  }
};
